"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.Menu = void 0;
var react_1 = __importStar(require("react"));
var StatelessMenu_1 = require("./StatelessMenu");
/**
 * {@link https://cultureamp.design/components/menu/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-menu--auto-hide-behaviours Storybook}
 */
var Menu = function (_a) {
    var button = _a.button, _b = _a.menuVisible, menuVisible = _b === void 0 ? false : _b, rest = __rest(_a, ["button", "menuVisible"]);
    var _c = (0, react_1.useState)(menuVisible), isMenuVisible = _c[0], setIsMenuVisible = _c[1];
    var toggleMenuDropdown = function () {
        setIsMenuVisible(!isMenuVisible);
    };
    var hideMenuDropdown = function () {
        setIsMenuVisible(false);
    };
    return (react_1["default"].createElement(StatelessMenu_1.StatelessMenu, __assign({}, rest, { isMenuVisible: isMenuVisible, toggleMenuDropdown: toggleMenuDropdown, hideMenuDropdown: hideMenuDropdown, 
        // `StatelessMenu` is one of the newer components, so it uses a render function,
        // as opposed to `React.cloneElement`.
        // `cloneElement` has its problems, mainly because it's somewhat magical, can lead
        // to unexpected behaviour, and it doesn't self document. Hence, the switch
        // to the render function. It would be nice if the `Menu` component also
        // used this pattern, but it's probably not worth the time and effort.
        renderButton: function (props) {
            return react_1["default"].cloneElement(button, __assign(__assign({}, props), { onClick: function (e) {
                    var _a, _b;
                    props.onClick(e);
                    (_b = (_a = button.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                }, onMouseDown: function (e) {
                    var _a, _b;
                    props.onMouseDown(e);
                    (_b = (_a = button.props).onMouseDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                } }));
        } })));
};
exports.Menu = Menu;
exports.Menu.displayName = "Menu";
//# sourceMappingURL=Menu.js.map